import * as StompJs from "@stomp/stompjs";
import { reload_order_list_all, api_order_search_list, api_order_list, api_order_type } from "../http/OrderConn";
import { fn_setting_config } from "http/SettingConn";
import { fn_bridge_log, fn_notify_close } from "./FnPosBridge";
import { fn_order_set_state, fn_emergency_notice } from "./FnBodyStep";
import { fn_setKitchenPrinterFlag, fn_setHookingFlag } from "function/FnBodySetting";
import { fn_log_error, fn_bridge_synchronize } from "function/FnPosBridge";
import { posOrderTab } from "utils/Utils";
export function fn_rabbitmq_stomp(rootStore) {
  const brokerUrl = rootStore.settingStore.ActiveRestUrl.abbitmq;
  // 주문 Rabbit Stomp 연결
  const client = new StompJs.Client({
    brokerURL: brokerUrl,
    connectHeaders: {
      login: "dum",
      passcode: "dum",
    },
    debug: function (str) {
      //console.log(str)
    },
    reconnectDelay: 5000, //자동 재 연결
    heartbeatIncoming: 4000,
    heartbeatOutgoing: 4000,
  });

  client.onConnect = function (frame) {
    const { searchStore } = rootStore;
    var routingKey = searchStore.getShopCd + "" + searchStore.getPosNo;

    let isStartStatus = false;
    let timeout; // 타임아웃 식별자를 저장할 변수

    timeout = setTimeout(() => {
      isStartStatus = true;
      clearTimeout(timeout);
    }, 3000);

    rootStore.rabbitMqStore.setTimeTimeout(timeout);
    rootStore.rabbitMqStore.setTimeIsStartStatus(isStartStatus);

    // true 실행 내부로직 false 스킵
    if (!rootStore.rabbitMqStore.getTimeIsStartStatus) {
      //todo
    }

    const queueName = routingKey + "_portal";
    const headers = {
      durable: true, // 영구키 설정
      "auto-delete": false, // 자동 삭제 옵션 설정
      "x-queue-name": queueName,
    };

    rootStore.rabbitMqStore.setRmqCheck(true);

    if (client.connected) {
      //멀티포스빼야됨
      client.subscribe(
        "/exchange/amq.direct/" + queueName,
        message => {
          if (message.body) {
            let data = JSON.parse(message.body);
            //동기화 완료 notify
            fn_log_error("", "Qtype", data.type);

            let mobileOrderNo = data.mobileOrderNo;
            if (data.type === "0" || data.type === "1" || data.type === "2") {
              //asp셋업 유->무:프린트설정N
              if (data.type === "1" || data.type === "0") {
                if (data.type === "0") {
                  fn_setHookingFlag(rootStore, false);
                }
                fn_setKitchenPrinterFlag(rootStore, false);
              }
              rootStore.settingStore.setPayFreeType(data.type);
            } else if (data.type === "OKGO_EMERGENCY_NOTICE") {
              //긴급공지사항
              fn_emergency_notice(rootStore, data);
            } else if (data.type === "LOG_SEND_SIGNAL") {
              //로그전송
              fn_bridge_log(rootStore, true);
            } else if (data.type === "CONFIG_CHANGE_SIGNAL") {
              //멀티포스 설정값 동기화
              fn_setting_config(rootStore, "rabbit");
            } else if (data.type === "CLOSE_NOTIFY_POPUP") {
              fn_notify_close(rootStore);
            } else if (data.type === "synchronize_order_complete") {
              api_order_search_list(rootStore).then(r => {
                api_order_list(rootStore);
                api_order_type(rootStore);
              });

              fn_bridge_synchronize(rootStore);
            } else {
              fn_order_set_state(rootStore, data);
              if (data.type != "memo" && !posOrderTab(rootStore)) {
                reload_order_list_all(rootStore);
              }
              if (data.type === "create") {
                if (data.mobileOrderFg != "22") {
                  rootStore.rabbitMqStore.addRabbitReadyNew(mobileOrderNo);
                }
              } else if (data.type === "HOOKING_ORDER_NEW") {
                rootStore.rabbitMqStore.addRabbitCookingNew(mobileOrderNo);
              } else if (data.type === "CID_ORDER_NEW") {
                rootStore.rabbitMqStore.addRabbitCookingNew(mobileOrderNo);
              } else if (data.type === "dlv_status") {
                if (data.dlvStatusFg === "04") {
                  if (rootStore.viewStore.getOrderDetail.mobileOrderNo === mobileOrderNo) {
                    rootStore.viewStore.setDetailClose();
                  }
                } else {
                  // 상세 객체 갱신
                  if (rootStore.viewStore.getOrderDetail.mobileOrderNo === mobileOrderNo) {
                    rootStore.viewStore.setChangeViewObj("dlvStatusFg", data.dlvStatusFg);
                    //rootStore.viewStore.setChangeViewObj("deliveryStatus", data.dlvStatusFg);
                    rootStore.viewStore.setChangeViewObj("deliveryStatusView", data.dlvStatusView);
                    rootStore.viewStore.setChangeViewObj("dlvReqTime", data.dlvReqTime);
                    rootStore.viewStore.setChangeViewObj("dlvAssignTime", data.dlvAssignTime);
                    rootStore.viewStore.setChangeViewObj("dlvPickupTime", data.dlvPickupTime);
                    rootStore.viewStore.setChangeViewObj("dlvDeliveryTime", data.dlvDeliveryTime);
                    rootStore.viewStore.setChangeViewObj("ptnerRiderTel", data.ptnerRiderTel);
                    rootStore.viewStore.setChangeViewObj("ptnerRiderNm", data.ptnerRiderNm);
                  }
                  rootStore.orderStore.changeOrderListDlv(data);
                }
              }
            }
          } else {
            fn_log_error("", "Rmq_Disconnect_no_Body", null);
          }
        },
        headers
      );
    } else {
      fn_log_error("", "Rmq_Disconnect_Error", null);
      rootStore.rabbitMqStore.setRmqCheck(false);
    }
  };

  // STOMP 프로토콜 에러 발생 시 호출
  client.onStompError = function (frame) {
    fn_log_error("", "Stomp", frame.body);
    rootStore.rabbitMqStore.setRmqCheck(false);
  };

  // 연결 종료 시 호출
  client.onDisconnect = function (frame) {
    console.log("Disconnected from RabbitMQ");
  };

  // 네트워크 에러 또는 서버 비정상 종료 시 호출
  client.onWebSocketClose = function (event) {
    console.error("WebSocket connection closed. Reason:", event.reason || event.code);
    rootStore.rabbitMqStore.setRmqCheck(false);
  };

  // 네트워크 에러 시 호출
  client.onWebSocketError = function (error) {
    console.error("WebSocket encountered an error:", error);
    rootStore.rabbitMqStore.setRmqCheck(false);
  };

  client.activate();

  return client;
}

// Ready상태 New상태 체크
export function fn_ready_new_order_yn(rootStore) {
  return rootStore.rabbitMqStore.getNewReadyNewYn;
}

// Cooking상태 New상태 체크
export function fn_cooking_new_order_yn(rootStore) {
  return rootStore.rabbitMqStore.getNewCookingNewYn;
}

// Delivery상태 New상태 체크
export function fn_delivery_new_order_yn(rootStore) {
  return rootStore.rabbitMqStore.getNewDeliveryNewYn;
}
